/**
 * Created by wafer on 2017/5/19.
 */
import request from '../utils/request';
import { Base64 } from 'js-base64';
import { parsePropertyToUrl } from '../utils/common';
import { AES, enc, mode, pad } from 'crypto-js';
import { downloadFile } from '../utils/download';

const SECRET_KEY = enc.Latin1.parse('dbd-d3d5-436a15d');
const SECRET_IV = enc.Latin1.parse('1234067802344678');

//isAll 0-根据权限筛选 1-查询全部
export const getAllZone = ({ locale, isAll = 0 }) => {
  const url = `/smartmeeting/smart/zone/v2/findAllZone`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      flag: 1,
      lang: locale,
      isAll
    })
  });
};

//获取登录用户的详细信息
export const getUserInfo = ({ locale }) => {
  const uri = `/iwork/userInfo/getUserInfo?lang=${locale}`;
  return request(uri);
};

// 设置域信息
export const setDomainInfo = ({ info, locale }) => {
  let param = JSON.parse(JSON.stringify(info));
  for (let key in param) {
    param[key] = encodeURIComponent(param[key]);
  }
  const uri =
    '/iwork/domain/updateDomain?id=' +
    param.id +
    '&address=' +
    (param.address || '') +
    '&city=' +
    (param.city || '') +
    '&domain=' +
    (param.domain || '') +
    '&email=' +
    (param.email || '') +
    '&name=' +
    (param.name || '') +
    '&postCode=' +
    (param.postCode || '') +
    '&telphone=' +
    (param.telphone || '') +
    '&website=' +
    (param.website || '') +
    '&logo=' +
    param.logo +
    '&lang=' +
    locale +
    '&defuserPwd=' +
    (param.defuserPwd || '') +
    '&ownSkin=' +
    (param.ownSkin || '') +
    '&useSkin=' +
    (param.useSkin || '');
  return request(uri);
};

// 区域
// 1.所有区域
export const findAllZone = ({ filter }) => {
  const url = `/smartmeeting/smart/zone/v2/findAllZone`;
  return request(url,{
    method: 'POST',
    body: JSON.stringify({
      isAll: filter.isAll,
      lang: filter.locale,
      pageNo: filter.pageNo || '',
      pageSize: filter.pageSize || '',
      flag: filter.flag,
      name: filter.name || '',
      capacity: filter.capacity || '',
      deviceIds: filter.deviceIds || '',
      teaIds: filter.teaIds || '',
      startTime: filter.startTime || '',
      endTime: filter.endTime || ''
    })
  });
};

// 2.保存
export const saveZone = ({ filter }) => {
  const url = `/smartmeeting/smart/zone/saveZone?lang=${filter.locale}&id=${
    filter.id
  }&sonName=${filter.sonName}&parName=${filter.parName}`;
  return request(url);
};
// 删除
export const deleteZone = ({ filter }) => {
  const url = `/smartmeeting/smart/zone/deleteZone?lang=${filter.locale}&id=${
    filter.id
  }`;
  return request(url);
};
// 更新
export const updateZone = ({ filter }) => {
  const url = `/smartmeeting/smart/zone/updateZone?lang=${filter.locale}`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      id: filter.id,
      name: filter.sonName
    })
  });
};

// deleteRome
export const deleteRoom = ({ locale, roomId }) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  const uri =
    '/smartmeeting/smart/third/deleteRoom?roomId=' +
    roomId +
    '&userId=' +
    (userInfo.userId + '@' + userInfo.domainName) +
    '&lang=' +
    locale +
    '&flag=0';
  return request(uri);
};

// 批量下线会议室
export const offLineRooms = ({ locale, roomIds, domainId }) => {
  const uri = `/smartmeeting/smart/offOrOn/offRooms?lang=${locale}&domainId=${domainId}`;
  return request(uri, { method: 'POST', body: JSON.stringify(roomIds) });
};

export const serviceLists = ({ pagination, locale, name, types }) => {
  const uri =
    '/smartmeeting/smart/third/findAllRooms?domainName=' +
    (sessionStorage.getItem('domainName') || '') +
    '&lang=' +
    locale +
    '&pageNo=' +
    (pagination.currentPage || 1) +
    '&pageSize=' +
    (pagination.pageSize || 5) +
    '&name=' +
    (name || '') +
    '&flag=' +
    (types == 1 ? 0 : 1);
  return request(uri);
};

export const getAppIndexConf = ({ locale }) => {
  const uri = `/smartmeeting/smart/appIndex/findAllAppIndex?lang=${locale}`;
  return request(uri);
};

export const updateAppConfState = ({ locale, id, state }) => {
  const url = `/smartmeeting/smart/appIndex/updateAppConfState?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      id,
      state
    })
  });
};

//会议室同步方法，保存、删除
export const serviceOperator = ({ service, locale }) => {
  const uri = `/smartmeeting/smart/third/synRoom?lang=${locale}`;
  const json = {};
  console.log(service)
  for (let key in service) {
    json[key] = service[key];
  }
  json['lang'] = locale;
  return request(uri, { method: 'POST', body: JSON.stringify(json) });
};
//tt类型1：会议室 2: 权限
export const deleteService = ({ roomId, locale, tt }) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  const uri =
    '/smartmeeting/smart/third/deleteRoom?roomId=' +
    roomId +
    '&userId=' +
    (userInfo.userId + '@' + userInfo.domainName) +
    '&lang=' +
    locale +
    '&flag=' +
    (tt == 1 ? 0 : 1);
  return request(uri);
};
export const addOrDelGroup = ({ group, locale }) => {
  let operator = 'saveGroup';
  let json = {};
  json.name = group.name;
  json.lang = locale;

  if (group.id) {
    operator = 'updateGroup';
    json.id = group.id;
  }
  let uri = '/iwork/group/' + operator;
  return request(uri, { method: 'POST', body: JSON.stringify(json) });
};
//检查用户信息是否被使用
export const checkUser = ({ user, locale }) => {
  //flag：标识位(1-用户名|2-手机号|3-邮箱)
  //num：用户名或手机号或邮箱
  const uri =
    '/iwork/userInfo/checkUser?num=' +
    user.num +
    '&domain=' +
    user.domainName +
    '&lang=' +
    locale +
    '&flag=' +
    user.flag +
    '&userId=' +
    (user.userId || '');
  return request(uri);
};
//分页获取用户列表
export const getUserListForPage = ({ condition, locale }) => {
  const uri = '/iwork/userInfo/getPageUser?';
  return request(uri, {
    method: 'POST',
    body: JSON.stringify({
      rows: condition.pageSize,
      page: condition.currentPage,
      lang: locale,
      term: condition.term || ''
    })
  });
};
//邀请
export const invitationUser = ({ data, locale }) => {
  const uri = '/iwork/invitUser/invit?lang=' + locale + '&data=' + data;
  return request(uri);
};
//用户信息的操作、删除、保存、修改
export const addOrDelUser = ({ user, saveOrUpdate, locale }) => {
  let uri = '';
  if (saveOrUpdate === 'delete') {
    uri = '/iwork/userInfo/delUser?lang=' + locale + '&userId=' + user.userId;
    return request(uri);
  } else {
    uri = '/iwork/userInfo/' + saveOrUpdate + '?lang=' + locale;
    return request(uri, {
      method: 'POST',
      body: JSON.stringify({ ...user, mobile: encodeURIComponent(user.mobile) })
    });
  }
};
//用户权限列表
export const userAuthorityList = ({ searchInfo, pagination, locale }) => {
  const uri =
    '/iwork/userAuth/getAllAuth?lang=' +
    locale +
    '&userName=' +
    (searchInfo.userName || '') +
    '&type=' +
    (typeof searchInfo.type == 'undefined' ? '' : searchInfo.type) +
    '&userId=' +
    (searchInfo.userId || '') +
    '&pemission=' +
    (searchInfo.permission || '') +
    '&page=' +
    pagination.currentPage +
    '&rows=' +
    pagination.pageSize;
  return request(uri);
};

//用户权限增删改查
export const userAuthorityOperator = ({ searchInfo, locale }) => {
  let uri = '';
  if (searchInfo.operator === 'save') {
    uri =
      '/iwork/userAuth/saveAuth?lang=' +
      locale +
      '&userName=' +
      searchInfo.userName +
      '&userId=' +
      searchInfo.userId +
      '&pemission=' +
      searchInfo.permission +
      '&type=' +
      searchInfo.type;
  } else if (searchInfo.operator === 'edit') {
    uri =
      '/iwork/userAuth/updateAuth?lang=' +
      locale +
      '&userId=' +
      searchInfo.userId +
      '&pemission=' +
      searchInfo.permission +
      '&id=' +
      searchInfo.id;
  } else if (searchInfo.operator === 'delete') {
    uri = '/iwork/userAuth/delAuth?lang=' + locale + '&id=' + searchInfo.id;
  }
  return request(uri);
};
//获取所有文件--分页
export const getFindAllFileList = ({ pagination, locale }) => {
  const uri =
    '/iwork/file/findAllFile?lang=' +
    locale +
    '&page=' +
    pagination.currentPage +
    '&rows=' +
    pagination.pageSize;
  return request(uri);
};
//用户信息的操作、删除、保存、修改
export const addOrDelFile = ({ file, saveOrUpdate, locale }) => {
  let uri = '';
  if (saveOrUpdate === 'delete') {
    uri = '/iwork/file/deleteFile?id=' + file.id;
  } else if (saveOrUpdate === 'save') {
    uri =
      '/iwork/file/' +
      saveOrUpdate +
      '?lang=' +
      locale +
      '&path=' +
      file.path +
      '&disk=' +
      file.disk +
      '&appType=' +
      file.appType +
      '&version=' +
      file.version +
      '&remark=' +
      file.remark +
      '&status=' +
      1;
  } else if (saveOrUpdate === 'update') {
    uri =
      '/iwork/file/' +
      saveOrUpdate +
      '?lang=' +
      locale +
      '&id=' +
      file.id +
      '&path=' +
      file.path +
      '&disk=' +
      file.disk +
      '&appType=' +
      file.appType +
      '&version=' +
      file.version +
      '&remark=' +
      file.remark +
      '&status=' +
      file.status;
  }
  return request(uri);
};

export const uploadAPK = ({ file, appType, version, locale }) => {
  let uri =
    '/iwork/file/uploadFile?type=4&lang=' +
    locale +
    '&userId=' +
    JSON.parse(sessionStorage.getItem('userInfo')).userId +
    '&fileName=' +
    appType +
    '_' +
    version;
  return request(uri, { method: 'POST', body: file });
};

//Exchange列表获取
export const findAllSystemMultiCofig = ({
  locale,
  type,
  status,
  currentPage,
  pageSize,
  category
}) => {
  const ulr = `/smartmeeting/smart/multiConfig/findAllSystemMultiCofig?lang=${locale}&type=${type}&status=${status}&pageNo=${currentPage}&pageSize=${pageSize}&category=${category}`;
  return request(ulr);
};
//Exchange列表获取
export const delSystemMultiCofig = ({ locale, id }) => {
  const ulr = `/smartmeeting/smart/multiConfig/delSystemMultiCofig?lang=${locale}&ids=${id}`;
  return request(ulr, { method: 'DELETE' });
};
//Exchange连通性测试
export const conenctionTest = ({ locale, exchange }) => {
  const url = `/smartmeeting/smart/multiConfig/conenctionTest?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      account: exchange.account || '',
      domainName: exchange.domainName || '',
      ip: exchange.ip || '',
      version: exchange.version || '',
      password: exchange.password || '',
      protocol: exchange.protocol || '',
      id: String(exchange.id) || 0,
      remark: exchange.remark || '',
      type: '1'
    })
  });
};
//获取office365信息
export const getOfficeAuthInfoFuc = ({ locale }) => {
  let url = `/iwork/officeAuth/getAuthInfo?lang=${locale}`;
  return request(url);
};

export const getAccessTokenFuc = ({ code, locale, token }) => {
  let url = `/iwork/officeAuth/getAccessToken?code=${code}&lang=${locale}`;
  return request(url, { headers: { token: token } });
};

//增加修改
export const saveOrUpdateExchange = ({ exchangeData, locale }) => {
  const url = `/smartmeeting/smart/multiConfig/saveOrUpdate?lang=${locale}&operateType=${exchangeData.operateType ||
    0}`;
  let json = {
    id: String(exchangeData.id || 0),
    protocol: exchangeData.protocol || '',
    version: exchangeData.version || '',
    ip: exchangeData.ip || '',
    account: exchangeData.account || '',
    password: exchangeData.password || '',
    remark: exchangeData.remark || '',
    type: '1',
    status: exchangeData.status || '1',
    operateType: String(exchangeData.operateType || 0),
    domainId: String(exchangeData.domainId || 0),
    domainName: exchangeData.domainName || '',
    myManage: exchangeData.myManage || '',
    params: exchangeData.params || '',
    port: exchangeData.port || ''
  };
  return request(url, { method: 'POST', body: JSON.stringify(json) });
};

export const getAllDeptment = ({ token, deptFrom, lang, level }) => {
  let url = `/iwork/dept/findDeptTrees?deptFrom=${deptFrom}&lang=${lang}`;
  return request(url, { headers: { token: token } });
};
//会议室管理，分配会议室组织结构需要到部门，这里由-1改为1，如果影响到别的业务请复制此方法改为1后调用
export const getAllCompanyWithOutDept = ({ token, deptFrom, lang }) => {
  let url = `/iwork/dept/findDeptTrees?deptFrom=${deptFrom}&lang=${lang}&level=-1`;
  return request(url, { headers: { token: token } });
};

// 新增
export const saveDept = ({ filter }) => {
  const url = `/iwork/dept/saveDept?lang=${filter.locale}&parId=${
    filter.parId
  }&sonName=${filter.sonName}`;
  return request(url);
};

// 修改
export const updateDept = ({ filter }) => {
  const url = `/iwork/dept/updateDept?lang=${filter.locale}&deptId=${
    filter.id
  }&name=${filter.sonName}`;
  return request(url);
};

// 删除
export const deleteDept = ({ filter }) => {
  const url = `/iwork/dept/deleteDept?lang=${filter.locale}&deptId=${
    filter.id
  }`;
  return request(url);
};

export const getUsersByRoleKey = ({ roleKey }) => {
  return request(`/iwork/userInfo/getAllUserByRole?roleKey=${roleKey}`);
};

export const getSmartServiceConfig = ({ locale }) => {
  const url = `/smartmeeting/smart/smartDevice/findAll?lang=${locale}`;
  return request(url);
};

export const getJonzyDeviceHost = ({ locale }) => {
  const url = `/smartmeeting/smart/jonzy/getDeviceHost?lang=${locale}`;
  return request(url);
};

export const getHostPanel = ({ locale, hostId }) => {
  const url = `/smartmeeting/smart/jonzy/getHostPanel?hostId=${hostId}`;
  return request(url);
};

export const deviceList = ({ types, locale }) => {
  const uri =
    '/smartmeeting/smart/meetingDevice/getAllDevice?includeDel=0&lang=' +
    locale +
    '&type=' +
    types;
  return request(uri);
};

// 删除
export const deleteDevice = ({ filter }) => {
  const url = `/smartmeeting/smart/meetingDevice/deleteDevice?lang=${
    filter.locale
  }&deviceId=${filter.deviceId}`;
  return request(url);
};

// 保存
export const saveDevices = ({ locale, data }) => {
  const url = `/smartmeeting/smart/meetingDevice/saveDevice?lang=${locale}`;
  return request(url, { method: 'POST', body: JSON.stringify({ data }) });
};

export const getAllMenus = locale => {
  return request(`/iwork/menuInfo/getAllMenu?lang=${locale}`);
};

export const getAllRoles = () => {
  return request(`/iwork/menuInfo/getAllRoles`);
};

export const getAllSupports = () => {
  return request(`/smartmeeting/smart/support/supports`);
};

export const findFrontDeskPhone = () => {
  return request(`/smartmeeting/smart/zone/findFrontDeskPhone`);
};

export const updateFrontDeskPhone = phone => {
  return request(
    `/smartmeeting/smart/zone/updateFrontDeskPhone?phone=${phone}`
  );
};

export const getRoomDevices = roomId => {
  return request(
    `/smartmeeting/smart/roomDevice/getRoomDevices?roomId=${roomId}`
  );
};

export const updateRoomDeviceState = params => {
  return request(
    `/smartmeeting/smart/roomDevice/updateRoomDeviceState?${parsePropertyToUrl(
      params
    )}`
  );
};

export const saveRole = ({ lang, data }) => {
  const url = `/iwork/role/save?lang=${lang}`;
  return request(url, { method: 'POST', body: JSON.stringify(data) });
};

export const saveSupport = params => {
  const url = `/smartmeeting/smart/support/saveOrUpdate?${parsePropertyToUrl(
    params
  )}`;
  return request(url, { method: 'POST' });
};

export const deleteRole = roleId => {
  return request(`/iwork/role/delete?roleId=${roleId}`, { method: 'DELETE' });
};

export const deleteSupport = supportId => {
  return request(`/smartmeeting/smart/support/delete?supportId=${supportId}`, {
    method: 'DELETE'
  });
};

export const getPageUserByRole = ({ roleId }) => {
  return request(`/iwork/userInfo/getPageUserByRole?roleId=${roleId}`);
};

export const searchRoleUsers = params => {
  return request(
    `/iwork/userInfo/searchRoleUsers?${parsePropertyToUrl(params)}`
  );
};

export const deleteRoleUser = ({ roleId, userId }) => {
  return request(
    `/iwork/role/deleteRoleUser?roleId=${roleId}&userId=${userId}`,
    { method: 'DELETE' }
  );
};

export const addRoleUsers = ({ roleId, userIds }) => {
  return request(
    `/iwork/role/addRoleUsers?roleId=${roleId}&userIds=${userIds}`,
    { method: 'POST' }
  );
};

/**
 * 根据关键词和关键词类型搜索用户，带分页信息
 *
 * */
export const searchUser = ({
  keyword,
  keyType,
  lang,
  current,
  pageSize,
  deptNodeCode = ''
}) => {
  return request(
    `/iwork/userInfo/getUsersByKeyword?keyword=${keyword}&keyType=${keyType}&current=${current}&lang=${lang}&pageSize=${pageSize}&deptNodeCode=${deptNodeCode}`
  );
};

//新增或更新用户
export const saveOrUpdateUser = ({ user, lang }) => {
  const userInfo = {
    userId: user.userId,
    firstName: user.firstName,
    givenName: user.givenName,
    mobile: user.mobile ? encodeURIComponent(user.mobile) : '',
    email: user.email ? encodeURIComponent(user.email) : '',
    company: user.company,
    dept: user.dept,
    deptId: user.deptId,
    deptNodeCode: user.deptNodeCode,
    position: user.position,
    avatar: user.avatar ? encodeURIComponent(user.avatar) : '',
    cardNo:user.cardNo
  };
  if (user.id) {
    return request(
      `/iwork/userInfo/updateUser?lang=${lang}&${parsePropertyToUrl(userInfo)}`
    );
  } else {
    return request(
      `/iwork/userInfo/saveUser?lang=${lang}&${parsePropertyToUrl(userInfo)}`
    );
  }
};

export const deleteUser = params => {
  return request(`/iwork/userInfo/delUser?${parsePropertyToUrl(params)}`);
};

export const resetPwd = params => {
  return request(`/iwork/userInfo/resetPwd?${parsePropertyToUrl(params)}`);
};
export const findRoomsByZoneId = ({
  locale,
  zoneId,
  name,
  filterByAdminUser
}) => {
  return request(
    `/smartmeeting/smart/zone/getAllRoomByZoneId?zoneId=${zoneId}&lang=${locale}&name=${encodeURIComponent(
      name
    )}&filterByAdminUser=${filterByAdminUser || 0}`
  );
};

export const recordActivityLog = params => {
  return request(
    `/smartmeeting/smart/third/activityLog?${encodeURI(
      parsePropertyToUrl(params)
    )}`
  );
};

export const getActivityLogs = params => {
  return request(
    `/smartmeeting/smart/third/activityLogs?${parsePropertyToUrl(params)}`
  );
};

export const updateRoomManagers = params => {
  return request(
    `/smartmeeting/smart/third/updateRoomManagers?${parsePropertyToUrl(params)}`
  );
};

export const saveTempSetting = params => {
  return request('/smartmeeting/smart/third/tempSetting', {
    method: 'POST',
    body: JSON.stringify(params)
  });
};

export const getTempSettings = page => {
  return request(`/smartmeeting/smart/third/tempSettings?page=${page || 1}`);
};

export const dropTempSetting = tempId => {
  return request(
    `/smartmeeting/smart/third/dropTempSetting?tempId=${tempId || 0}`
  );
};

export const changeZoneOrd = params => {
  return request(
    `/smartmeeting/smart/zone/changeZoneOrd?${parsePropertyToUrl(params)}`
  );
};

/**
 * 获得所有服务等级
 * @param lang
 * @returns {Object}
 */
export const getLevels = ({ lang }) => {
  return request(`/smartmeeting/smart/meetingsvc/levels?lang=${lang}`);
};

/**
 * 获取全部服务
 * @returns {Object}
 */
export const getServices = params => {
  return request(
    `/smartmeeting/smart/meetingsvc/getAllSvc?${parsePropertyToUrl(params)}`
  );
};

/**
 * 获取所有服务的类型
 * @returns {Object}
 */
export const getSvcTypes = params => {
  return request(
    `/smartmeeting/smart/meetingsvc/getAllSvcType?${parsePropertyToUrl(params)}`
  );
};

export const getCleaningPersons = params => {
  return request(
    `/smartmeeting/smart/cleaningPerson/findAll?${parsePropertyToUrl(params)}`
  );
};

/**
 * 增加|编辑服务等级
 * @param lang
 * @param data
 * @returns {Object}
 */
export const saveSvcLevel = ({ lang, data }) => {
  return request(
    `/smartmeeting/smart/meetingsvc/saveOrUpdateSvcLevel?lang=${lang}`,
    {
      method: 'POST',
      body: JSON.stringify(data)
    }
  );
};

/**
 * 增加|编辑服务等级
 * @param lang
 * @param data
 * @returns {Object}
 */
export const saveCleaningPerson = ({ lang, data }) => {
  return request(
    `/smartmeeting/smart/cleaningPerson/saveOrUpdate?lang=${lang}`,
    {
      method: 'POST',
      body: JSON.stringify(data)
    }
  );
};


/**
 * 增加|编辑服务
 * @param lang
 * @param data
 * @returns {Object}
 */
export const saveService = ({ lang, data }) => {
  return request(
    `/smartmeeting/smart/meetingsvc/saveOrUpdateSvc?lang=${lang}`,
    {
      method: 'POST',
      body: JSON.stringify(data)
    }
  );
};

/**
 * 删除服务等级
 * @param lang
 * @param id
 * @returns {Object}
 */
export const deleteSvcLevel = ({ lang, id }) => {
  return request(`/smartmeeting/smart/meetingsvc/deleteLevel`, {
    method: 'POST',
    body: JSON.stringify({
      id: id,
      lang: lang
    })
  });
};

/**
 * 删除服务等级
 * @param lang
 * @param id
 * @returns {Object}
 */
export const deleteCleaning = ({ lang, id }) => {
  return request(`/smartmeeting/smart/cleaningPerson/deleteCleaning`, {
    method: 'POST',
    body: JSON.stringify({
      id: id,
      lang: lang
    })
  });
};

/**
 * 删除服务项
 * @param lang
 * @param id
 * @returns {Object}
 */
export const deleteSvc = ({ lang, id }) => {
  return request(`/smartmeeting/smart/meetingsvc/delSvc`, {
    method: 'POST',
    body: JSON.stringify({
      id: id,
      lang: lang
    })
  });
};

export const getLendList = ({ pageNo, pageSize }) => {
  return request(
    `/smartmeeting/smart/meetingDevice/getLendList?pageNo=${pageNo}&pageSize=${pageSize}`,
    {
      method: 'POST',
      body: JSON.stringify({ pageNo, pageSize }),
      headers: { 'Content-Type': 'application/json' }
    }
  );
};

export const updateLendState = ({ id, lendState, lang }) => {
  return request(`/smartmeeting/smart/meetingDevice/updateLendState?lang=${lang}`, {
    method: 'POST',
    body: JSON.stringify({
      meetingDeviceId: id,
      lendState: lendState
    })
  });
};

export const updateVideoApply = ({ meetingVideo }) => {
  const url = `/smartmeeting/smart/meetingvideo/updateVideoApply`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      meetingId: meetingVideo.meetingId,
      state: meetingVideo.state,
      maintains: JSON.stringify(meetingVideo.mainTains)
    })
  });
};

export const pubLiveVideo = ({ params }) => {
  const url = `/smartmeeting/smart/meetingvideo/pubLiveVideo`;
  let data = {
    action: params.action,
    meetingId: params.meetingId,
    liveUrl: params.liveUrl,
    liveStartTime: params.liveStartTime,
    liveEndTime: params.liveEndTime,
    userList: Base64.encode(JSON.stringify(params.userList))
  };
  return request(url, { method: 'POST', body: JSON.stringify(data) });
};

export const pubRecordVideo = ({ params }) => {
  const url = `/smartmeeting/smart/meetingvideo/pubRecordVideo`;
  let data = {
    action: params.action,
    meetingId: params.meetingId,
    recordVideos: SON.stringify(params.selectedVideo),
    userList: Base64.encode(JSON.stringify(params.userList))
  };
  return request(url, { method: 'POST', body: JSON.stringify(data) });
};

export const getVideosByMeetingId = ({ meetingId }) => {
  const url = `/smartmeeting/smart/player/findVideoFile`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify({ meetingId: meetingId })
  });
};

export const saveDevice = ({ deviceInfo, lang }) => {
  return request(`/smartmeeting/smart/meetingDevice/saveDevice?lang=${lang}`, {
    method: 'POST',
    body: JSON.stringify(deviceInfo)
  });
};

export const updateDevice = ({ deviceInfo, lang }) => {
  return request(`/smartmeeting/smart/meetingDevice/updateDevice?lang=${lang}`, {
    method: 'POST',
    body: JSON.stringify(deviceInfo)
  });
};

export const getDeviceBindRoomList = (lang, deviceId) => {
  return request(
    `/smartmeeting/smart/meetingDevice/getDeviceBindRoomList?lang=${lang}&deviceId=${deviceId}`
  );
};

/**
 * 获取申请了会议服务的会议信息
 * @param pageNo
 * @param pageSize
 * @returns {Object}
 */
export const getAllMeetingVideo = ({ pageNo, pageSize }) => {
  return request(
    `/smartmeeting/smart/meetingvideo/getAllMeetingVideo?current=${pageNo}&pageSize=${pageSize}`,
    {
      method: 'POST',
      body: JSON.stringify({ pageNo, pageSize }),
      headers: { 'Content-Type': 'application/json' }
    }
  );
};

export const getAllHoliday = (lang, year) => {
  return request(
    `/smartmeeting/smart/holiday/getAllHoliday?lang=${lang}&year=${year}`
  );
};

export const getWeekTime = (lang, year) => {
  return request(
    `/smartmeeting/smart/holiday/getWeekTime?lang=${lang}&year=${year}`
  );
};

export const saveWeekTime = params => {
  return request(
    `/smartmeeting/smart/holiday/saveWeekTime?${parsePropertyToUrl(params)}`
  );
};

export const setWorkDay = params => {
  return request(
    `/smartmeeting/smart/holiday/deleteSingleHoliday?${parsePropertyToUrl(
      params
    )}`
  );
};

export const setHoliday = params => {
  return request(
    `/smartmeeting/smart/holiday/saveSingleHoliday?${parsePropertyToUrl(
      params
    )}`
  );
};

export const checkRoomAdmin = ({ userId }) => {
  return request(`/smartmeeting/smart/zone/checkRoomAdmin?userId=${userId}`);
};

export const getNoticeManage = lang => {
  return request(`/smartmeeting/smart/third/getNoticeManage?lang=${lang}`);
};
export const updateNoticeConfig = (noticeConfig, lang) => {
  return request(`/smartmeeting/smart/third/updateNoticeConfig?lang=${lang}`, {
    method: 'POST',
    body: JSON.stringify(noticeConfig)
  });
};

export const getInfCheckTime = lang => {
  return request(`/smartmeeting/smart/knddevice/getInfCheckTime?lang=${lang}`);
};

export const saveInfCheckTime = ({checkTime, lang}) => {
  return request(`/smartmeeting/smart/knddevice/saveInfCheckTime/${checkTime}?lang=${lang}`, {
    method: 'PUT',
  });
};

export const getDisplayboardEnergy = lang => {
  return request(
    `/smartmeeting/smart/board/getDisplayboardEnergy?lang=${lang}`
  );
};
export const setDisplayboardEnergy = ({ mode, powerOn, powerOff, lang }) => {
  return request(
    `/smartmeeting/smart/board/setDisplayboardEnergy?lang=${lang}`,
    { method: 'POST', body: JSON.stringify({ mode, powerOn, powerOff }) }
  );
};
//获取Cisco会议室终端
export const findCmmaDevice = ({ cmmaRoomId }) => {
  const uri =
    '/smartmeeting/smart/third/findCmmaDevice?cmmaRoomId=' + cmmaRoomId;
  return request(uri);
};
//保存Cisco会议室终端
export const synCmmaDevice = payload => {
  const uri = '/smartmeeting/smart/third/synCmmaDevice';
  return request(uri, { method: 'POST', body: JSON.stringify(payload) });
};
//删除Cisco会议室终端
export const deleteCmmaDevice = cmmaRoomId => {
  const url = `/smartmeeting/smart/third/deleteCmmaDevice?cmmaRoomId=${cmmaRoomId}`;
  return request(url);
};

//获取策略配置
export const getMeetingPolicy = lang => {
  const url = `/smartmeeting/smart/policy/meetingPolicy?lang=${lang}`;
  return request(url);
};

//获取NoticeState
export const getNoticeState = lang => {
  const url = `/iwork/noticeState/getState?lang=${lang}`;
  return request(url);
};

/**
 * 获取延迟会议信息
 */
export const getDelayMeetingFun = ({ locale, meetingId }) => {
  return request(
    `/smartmeeting/smart/third/findMeetingDetail?lang=${locale}&meetingId=${meetingId}`
  );
};

/**
 * 延迟会议提交
 * @param params
 * @param locale
 */
export const delayMeetingFun = ({ params, locale, userId, meetingId }) => {
  return request(
    `/smartmeeting/smart/board/delay?meetingId=${meetingId}&userId=${userId}&interval=${
      params.delayTime
    }&lang=${locale}`,
    { method: 'POST' }
  );
};

export const saveMeetingPolicy = ({ meetingPolicy, lang }) => {
  return request(`/smartmeeting/smart/policy/meetingPolicy?lang=${lang}`, {
    method: 'POST',
    body: JSON.stringify(meetingPolicy)
  });
};

export const saveRemindTime = ({ remindTime, lang }) => {
  const url = `/iwork/noticeState/saveTimeSet?data=${remindTime}&lang=${lang}`;
  return request(url);
};

export const submitFace = params => {
  return request(`/iwork/userInfo/submitFace?lang=${params.lang}`, {
    method: 'POST',
    body: JSON.stringify(params)
  });
};

export const setCommonZone = ({ lang, commonZoneIds }) => {
  return request(
    `/iwork/userInfo/setCommonZone?lang=${lang}&commonZoneIds=${commonZoneIds}`,
    { method: 'POST' }
  );
};

export const getDomainInformation = ({ locale, domain }) => {
  return request(
    `/iwork/domain/getDomainInformation?lang=${locale}&domain=${domain}`
  );
};
export const saveMaxDelayTimeFunc = ({ locale, maxDelayTime }) => {
  return request(`/smartmeeting/smart/policy/saveMaxDelayTime?lang=${locale}`, {
    method: 'POST',
    body: JSON.stringify({maxDelayTime})
  });
};


export const updateBillingSwitchFun = ({value = 0,locale}) => {
  return request(`/smartmeeting/smart/policy/saveBillingSwitch?lang=${locale}`, {
    method: 'POST',
    body: JSON.stringify({value})
  });
};

export const getMaxDelayTimeFunc = ({ locale, meetingId }) => {
  const url = `/smartmeeting/smart/policy/getMaxDelayTime?lang=${locale}&meetingId=${meetingId}`;
  return request(url);
};

export const modifyPwd = ({lang, pwdInfo: {oldPwd, newPwd}}) => {
  const encOldPwd = AES.encrypt(oldPwd, SECRET_KEY, {
    iv: SECRET_IV,
    mode: mode.CBC,
    padding: pad.ZeroPadding
  }).toString();
  const encNewPwd = AES.encrypt(newPwd, SECRET_KEY, {
    iv: SECRET_IV,
    mode: mode.CBC,
    padding: pad.ZeroPadding
  }).toString();

  return request(`/iwork/userInfo/modifyPwd?lang=${lang}`, {
    method: 'POST', body: JSON.stringify({
      oldPwd: encOldPwd,
      newPwd: encNewPwd
    })
  });
};

export const getSysParams = ({ locale }) => {
  const uri = `/iwork/global/getParameters?lang=${locale}`;
  return request(uri);
};

export const saveSysParam = ({ locale, payload }) => {
  const uri = `/iwork/global/saveParameter?lang=${locale}`;
  return request(uri, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const getDataDictionarys = ({ locale }) => {
  const uri = `/smartmeeting/smart/third/getDataDictionarys?lang=${locale}`;
  return request(uri);
};

export const saveDictionary = ({ locale, payload }) => {
  const uri = `/smartmeeting/smart/third/saveDictionary?lang=${locale}`;
  return request(uri, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const setRoomMaintain = ({locale, payload})=>{
  return request(`/smartmeeting/smart/third/setRoomMaintain?lang=${locale}`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const getLicenseInfo = ({ locale }) => {
  const uri = `/iwork/serviceAuth/license?lang=${locale}`;
  return request(uri);
};

export const updateLicense = ({locale, value})=>{
  return request(`/iwork/serviceAuth/license?lang=${locale}`, {
    method: 'POST',
    body: JSON.stringify({value:value})
  });
};

export const downloadLogFile = ({ payload, locale }) => {
  const {serverName, startDate, endDate, logLevel} = payload;
  const urlParam = `?serverName=${serverName}&startDate=${startDate}&endDate=${endDate}&logLevel=${logLevel}&lang=${locale}`;
  let url = "";
  if("iwork" == serverName){
    url = "/iwork/global/downloadLogFile";
  } else if("notice" == serverName) {
    url = "/notice/init/downloadLogFile";
  } else if("meeting" == serverName) {
    url = "/smartmeeting/smart/third/downloadLogFile";
  } else if("socket" == serverName) {
    url = "/socket/log/downloadLogFile";
  } else if("syncmeeting" == serverName) {
    url = "/syncmeeting/log/downloadLogFile";
  } else if("syncuser" == serverName) {
    url = "/syncuser/log/downloadLogFile";
  }
  if(url) {
    downloadFile('', url + urlParam);
  }
};
export const findAllBoardVersionFnc = ({locale}) => {
  const url = `/smartmeeting/smart/board/findAllBoardVersion?lang=${locale}`;
  return request(url);
};
export const saveBoardVersion = ({ versionInfo, locale }) => {
  return request(`/smartmeeting/smart/board/saveBoardVersion?lang=${locale}`, {
    method: 'POST',
    body: JSON.stringify(versionInfo)
  });
};
// 应用展板版本
export const applyBoardVersion = ({id, locale}) => {
  return request(`/smartmeeting/smart/board/applyBoardVersion?lang=${locale}`, {
    method: 'POST',
    body: JSON.stringify({id: id})
  });
};


export const  updatePolicyItem = ({key,value,locale}) => {
  return request(`/smartmeeting/smart/policy/updatePolicyItem?lang=${locale}`, {
    method: 'POST',
    body: JSON.stringify({key,value})
  });
}



// WEBPACK FOOTER //
// ./src/services/account.js